<template>
	<div class="pwidth">
	    <div class=" arrow l-h-50 m-t-10 m-b-10">
	        <el-breadcrumb separator-class="el-icon-arrow-right">
	            <el-breadcrumb-item>你所在的位置：</el-breadcrumb-item>
	            <el-breadcrumb-item> 资料下载</el-breadcrumb-item>
	
	        </el-breadcrumb>
	    </div>
	
	    <div class="m-b-20  bg-f min-h-500" >
	
	
			<div class="p-20">
			    <div>
			        <h3 class="m-b-20"><i class="shu m-r-5"></i> 资料下载</h3>
					
					<el-form ref="form" :model="form" label-width="68px" >
						<div class="flex start">
							
							<div class="w29">
								<el-form-item label="资料类型">
								<el-select v-model="dowmtype" placeholder="请选择资料类型" @change="changedowmtype">
								    <el-option
								      v-for="item in  [{value: 0,label: '商品资料下载'},{value: 1,label: '厂家资料下载'}]" :key="item.value" :label="item.label" :value="item.value">
								    </el-option>
								  </el-select>
								</el-form-item>
							</div>
							<div class="w29 m-r-20" v-if="dowmtype==0">
								<el-form-item label="通用名称">
									<el-input v-model.trim="query" placeholder="请输入通用名称 / 批准文号"></el-input>
								</el-form-item>
							</div>
							<div class="w29 m-r-20" v-if="dowmtype==1">
								<el-form-item label="厂家名称">
									<el-input v-model.trim="query" placeholder="请输入厂家名称"></el-input>
								</el-form-item>
							</div>
						  <!-- <div class="w29">
						  	<el-form-item label="商品批号">
						  		<el-input v-model.trim="form.batchno" placeholder="请输入商品批号"></el-input>
						  	</el-form-item>
						  </div>
						  
						  <div class="w29">
						  	<el-form-item label="批准文号">
						  		<el-input v-model.trim="form.approvalno" placeholder="请输入批准文号"></el-input>
						  	</el-form-item>
						  </div> -->
						  <div class="">
						  	<div class="w-60 h-40 l-h-40 tc c-f bg-b14e rad-4 cursor" @click="getgoodslsit">搜索</div>
						  </div>
						</div>
					 </el-form>
			    </div>
				
				<div v-if="goodslist.length">
				    <h3 class="m-b-20"><i class="shu-2 m-r-5"></i>查询结果</h3>
					<div v-for="(item,index) in goodslist" :key="index" class="m-b-20">
						<!-- <img class="w-20 h-20" src="../../assets/img/pdf.png" > -->
					    
						<span v-if="dowmtype==0">
							<span class="w-300 i-b">商品名称：{{item.goodsname}}</span>
							<span class="w-150 i-b">商品编码：{{item.goodsid}}     </span>
							<span class="w-150 i-b">产品单位：{{item.unit}}        </span>
							<span class="w-200 i-b">产品规格：{{item.spec}}        </span>
							<span class="w-200 i-b">包装规格：{{item.pakegespce}}  </span>
							
						</span>
						<span v-if="dowmtype==1">
							<span class="w-400 i-b">厂家名称：{{item.manufacturersname}}</span>
							<span class="w-400 i-b">厂家编码：{{item.manufacturersno}}     </span>
						</span>
										
					    <span class="c-b14e cursor border-a-00b-1 p-5-10 l-h-25" @click="downzpi(item)">
					        <i><img src="../../assets/img/download.png" alt=""></i>
					        点击下载
					    </span>
					</div>
				</div>
					<div v-if="!goodslist.length" class="tc ">
						<img class="w-200 h-150 m-t-100 c-9" src="../../assets/img/sc-1.png" >
						<p>暂无数据</p>
						
					</div>
					 
					 
			 </div>
	    </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				dowmtype:0,
				headerNav: '',
				query:'',
				form: {
					name: '',
					goodsno: '',
					batchno: '',
				    approvalno:'',
				},
				goodslist:[],
			}
		},
		created: function created() {
			this.headerNav = sessionStorage.getItem('headerNavs');
		},
		methods: {

			//查询商品列表
			getgoodslsit() {
				var form=this.form
				var {dowmtype}=this
				var url=dowmtype==0?'/b2bgoods/querycategorygoods':'/b2bgoods/manufacturers'
				var data = {
					batchno:this.batchno, query: this.query,pageno: 1,pagesize:30,isloadbatch: false,ispromotesalesid:''
				};
				this.requset(url, data).then((res)=>{
					console.log(res)
					this.goodslist=res.data||[]
				});
				
			},
			
			changedowmtype(e){
				console.log(e)
				this.goodslist=[]
			},

			downzpi(item){
				this.downloadExcel(item)
				// this.requset('/baseinfo/downfiledata', {
				// 	type:this.dowmtype,
				// 	query:this.dowmtype==0?item.goodsno:item.manufacturersname
				// }).then((res)=>{
				// 	console.log(res)
					
				// });
			},
			
			
			  // 下载POST 
			downloadExcel(item) {
				var self=this
				var {dowmtype}=this
				var orgno = sessionStorage.getItem('orgno');
				var tenantid = sessionStorage.getItem('tenantid');
				var url =this.serve+ `/baseinfo/downfiledata?tenantid=${tenantid}&orgno=${orgno}&type=${dowmtype}&query=${dowmtype==0?item.goodsno:item.manufacturersname}`;
				var downloadname=dowmtype==0?item.goodsno+item.goodsname:item.manufacturersname
				var xhr = new XMLHttpRequest();
				var loading = this.$loading({lock: true,text: '正在加载 请稍后 ...',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
				xhr.open('POST', url, true); // 也可以使用POST方式，根据接口
				xhr.responseType = "blob"; // 返回类型blob
				xhr.onload = function (e) {
				   loading.close();
				  if (this.status === 200) {
					var blob = this.response;
					console.log('blob',blob,blob.size)
					if(blob.size<200)return self.$message({message: '没有找到资料',type: 'error'})
					var reader = new FileReader();
					reader.readAsDataURL(blob); // 转换为base64，可以直接放入a表情href
					reader.onload = function (e) {
					  var a = document.createElement('a');
					  // a.download = self.genUUID() + (downloadname !== '' ? '_' + downloadname : '') + '.zip'; //下载文件名
					  a.download =  ( downloadname +'_')+self.genUUID() + '.zip'; //下载文件名
					  a.href = e.target.result;
					  a.click();
					};
				  }
				}; 
				xhr.send();
			},
			
			genUUID() {
				return 'yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
					var r = Math.random() * 16 | 0,
						v = c == 'x' ? r : r & 0x3 | 0x8;
					return v.toString(16);
				});
			}
		}
	}
</script>

<style>
	.el-form-item__label{color:#666;}
</style>
